import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { KeyboardArrowRightOutlined } from '@mui/icons-material';
import landingImage from '../../assets/other/landing-image.png';
import patternImage from '../../assets/other/pattern.png';
import blobImage from '../../assets/other/blobImage.png';
import { NAVIGATOR_CONTANTS_DATA } from '../../contants/NavigatorPageConstant';
import Modal from '../../components/Modal';

function BusinessNavigatorLanding() {
    const [videoOpen, setVideoOpen] = useState(false);

    const theme = useTheme();

    const takeATourButtonHandler = () => {
        setVideoOpen(true);
    };

    const closeVideoModal = () => {
        setVideoOpen(false);
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    margin: '0rem',
                    height: `calc(100% + 0rem)`,
                    width: `calc(100% + 0rem)`,
                    overflow: 'auto',

                    position: 'relative',

                    background: theme.palette.background.neutralSecondary,

                    backgroundImage: `url(${blobImage})`,
                    backgroundPosition: 'bottom right',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',

                    '@media (max-width:1300px)': {
                        backgroundImage: `unset`,
                    },

                    '@media (max-width:600px)': {
                        backgroundImage: `unset`,
                    },
                }}
            >
                <Box
                    sx={{
                        height: '100%',
                        width: '50%',

                        padding: '24px',
                        minWidth: '380px',
                        zIndex: 999,

                        '@media (max-width:1300px)': {
                            width: '100%',
                        },
                        '@media (max-width:600px)': {
                            width: '100%',
                        },
                    }}
                >
                    <Typography component="h1" variant="heading1" color={'text.primary'} fontFamily={'fontFamilyCondensed'}>
                        {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.heading}
                    </Typography>
                    <Typography component="p" variant="heading2" color={'text.secondary'} fontFamily={'fontFamilyCondensed'} marginTop={'0.5rem'}>
                        {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.subHeading}
                    </Typography>

                    <Divider sx={{ margin: '1.5rem 0' }} />

                    <Box marginTop={'2rem'}>
                        <Typography component="h2" variant="heading3" color={'text.secondary'} marginBottom={'1rem'}>
                            {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.intro}
                        </Typography>
                        <Typography component="p" variant="paraText3" color={'text.secondary'} marginBottom={'1rem'}>
                            {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.para}
                        </Typography>
                        <Typography component="p" variant="paraText3" color={'text.secondary'} marginBottom={'1rem'}>
                            {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.para1}
                        </Typography>
                        <Typography component="p" variant="paraText3" color={'text.secondary'} marginBottom={'1rem'}>
                            {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.para2}
                        </Typography>

                        <Button variant="contained" size="large" onClick={takeATourButtonHandler} endIcon={<KeyboardArrowRightOutlined />} sx={{ marginTop: '1rem' }}>
                            {NAVIGATOR_CONTANTS_DATA.Landing_DescriptioDetails.buttonText}
                        </Button>
                    </Box>
                </Box>

                <Box
                    component={'img'}
                    src={landingImage}
                    alt=""
                    sx={{
                        // height: '100%',
                        // width: '100%',

                        position: 'absolute',
                        bottom: '0px',
                        right: '0px',

                        height: '100%',

                        '@media (max-width:1300px)': {
                            display: 'none',
                        },
                        '@media (max-width:600px)': {
                            display: 'none',
                        },
                    }}
                ></Box>

                <Box
                    component={'img'}
                    src={patternImage}
                    alt=""
                    sx={{
                        height: '120px',
                        width: '245px',
                        position: 'absolute',
                        bottom: '0',
                        right: '270px',

                        '@media (max-width:1300px)': {
                            display: 'none',
                        },
                        '@media (max-width:600px)': {
                            display: 'none',
                        },
                    }}
                ></Box>

                {false && (
                    <Box
                        sx={{
                            // backgroundImage: `url(${blobImage})`,
                            // backgroundPosition: 'bottom right',
                            // backgroundRepeat: 'no-repeat',
                            // backgroundSize: 'cover',

                            position: 'absolute',
                            bottom: '0px',
                            right: '0px',

                            height: '100%',
                            width: '100%',

                            '@media (max-width:1300px)': {
                                display: 'none',
                            },

                            '@media (max-width:600px)': {
                                display: 'none',
                            },
                        }}
                    >
                        {/* <Box
                        sx={{
                            backgroundImage: `url(${landingImage})`,
                            backgroundPosition: 'bottom right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100%',
                            height: '100%',
                            width: '100%',
                            position: 'relative',
                        }}
                    >
                        <Box
                            sx={{
                                backgroundImage: `url(${patternImage})`,
                                backgroundPosition: 'bottom left',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '250px',
                                height: '300px',
                                width: '300px',
                                position: 'absolute',
                                bottom: '0',
                                left: 0,
                            }}
                        ></Box>
                    </Box> */}
                    </Box>
                )}

                <Modal
                    modalOpen={videoOpen}
                    hideActions={true}
                    title={null}
                    isBackdropCloseOn={true}
                    handleModalClose={closeVideoModal}
                    sx={{
                        '& .MuiPaper-root.MuiDialog-paper': {
                            background: 'transparent',
                            overflowY: 'unset',
                        },
                        '& .MuiDialogContent-root': {
                            padding: theme.spacing(0),
                            borderTop: 'unset',
                            borderBottom: 'unset',
                        },
                    }}
                    iconButtonSx={{
                        color: '#fff',
                        position: 'absolute',
                        right: 0,
                        top: '-35px',
                    }}
                >
                    {/* for youtube */}
                    {/* <iframe
                        title="Tour Video"
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/dQw4w9WgXcQ" // replace with your video
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            // position: 'absolute',
                            // top: 0,
                            // left: 0,
                            width: '100%',
                            height: '400px',
                            // display:"none"
                            display: 'block',
                            verticalAlign: 'top',
                            borderRadius: '10px',
                        }}
                    /> */}

                    <video
                        controls
                        autoPlay
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '400px',
                            borderRadius: '10px',
                            verticalAlign: 'top',
                            boxSizing: 'border-box',
                            margin: 0,
                            padding: 0,
                            background: 'rgba(22, 28, 36, 0.8)',
                        }}
                    >
                        <source src="https://d1uii53avokzt7.cloudfront.net/Business-Navigator-Video.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </Modal>
            </Box>
        </>
    );
}

export default BusinessNavigatorLanding;
